export const membershipPagesRouterMatches = () => ({
    myTripsReactivation: /^\/?(?:travel\/membership-pages\/)?membership_mytrips_reactivation\/(.*)/,
    membership_retention: /^\/?(?:travel\/membership-pages\/)?membership_retention\/(.*)/,
    membership_cancellation: /^\/?(?:travel\/membership-pages\/)?membership_cancellation\/(.*)/,
    membership_cancellation_request: /^\/?(?:travel\/membership-pages\/)?membership_cancellation_request\/(.*)/,
    right_of_withdrawal: /^\/?(?:travel\/membership-pages\/)?right_of_withdrawal\/(.*)/,
    remediation_request: /^\/?(?:travel\/membership-pages\/)?remediation_request\/(.*)/,
    remediation_process: /^\/?(?:travel\/membership-pages\/)?remediation_process\/(.*)/,
});

export const membershipPagesAppChangePages = () => ({
    secure: {
        membership_mytrips_reactivation: 'membershippages',
        membership_retention: 'membershippages',
        membership_cancellation: 'membershippages',
        membership_cancellation_request: 'membershippages',
        right_of_withdrawal: 'membershippages',
        remediation_request: 'membershippages',
        remediation_process: 'membershippages',
    },
    membershippages: {
        membership_mytrips_reactivation: 'myTripsReactivation',
        membership_retention: 'membership_retention',
        membership_cancellation: 'membership_cancellation',
        membership_cancellation_request: 'membership_cancellation_request',
        right_of_withdrawal: 'right_of_withdrawal',
        remediation_request: 'remediation_request',
        remediation_process: 'remediation_process',
    },
});

export const membershipPagesSecurePages = () => ({
    membership_mytrips_reactivation: 'membershippages',
    membership_retention: 'membershippages',
    membership_cancellation: 'membershippages',
    membership_cancellation_request: 'membershippages',
    right_of_withdrawal: 'membershippages',
    remediation_request: 'membershippages',
    remediation_process: 'membershippages',
});
